import withErrorBoundary from '../../hocs/withErrorBoundary';
import './Map.css';
import MapWithTracking from './MapWithTracking';

const GoogleMap = withErrorBoundary(MapWithTracking);

export default GoogleMap;
